import * as React from "react";
function SvgRings(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M33.5 14.8C32.5 5.6 24.2-1 15 .1S-.7 9.5.4 18.6c.8 7.5 6.6 13.5 14.1 14.6 1 9.2 9.3 15.8 18.5 14.7 9.2-1.1 15.7-9.4 14.7-18.5-.9-7.5-6.7-13.5-14.2-14.6zM16.8 31c.2-7.8 6.6-14 14.4-14h.1c-.2 7.9-6.6 14.1-14.5 14zM2.5 16.7C2.4 8.8 8.7 2.2 16.6 2.1 23.9 2 30.1 7.3 31 14.6c-9 0-16.4 7.2-16.7 16.2-6.8-1.2-11.8-7.2-11.8-14.1zm28.7 29c-7.1 0-13.2-5.2-14.2-12.2 9 0 16.4-7.2 16.7-16.2 7.8 1.3 13 8.7 11.7 16.5-1.2 6.9-7.2 11.9-14.2 11.9z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgRings);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
